import { Component, OnInit } from '@angular/core';
import { MenuItem } from './menu-item';
import { HttpClient } from '@angular/common/http';
import { PrincipalService } from '../../security/authentication/principal.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  items: MenuItem[] = [];
  path: string;
  constructor(private http: HttpClient, public principalService: PrincipalService) {
    this.path = '@./assets/config-files/menu.json';
  }

  ngOnInit() {
    this.loadMenu().subscribe((data: MenuItem[]) => {
      this.items = data;
    });
  }

  public loadMenu() {
    // TODO: Se usa el flag @ para evitar que el interceptor añada la baseUrl del backend.
    // Buscar otra manera de hacer esto.
    return this.http.get(this.path);
  }
}
